
import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const phoneNumber = "+33643581540";
  const message = "Bonjour Julycia ! J'aimerais discuter d'un projet de communication avec vous.";
  
  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      {/* Main floating button */}
      <div className="fixed bottom-8 right-8 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-blue-600 text-white p-4 hover:bg-navy-900 transition-all duration-300 transform hover:scale-110 shadow-xl"
        >
          {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
        </button>
      </div>

      {/* Popup menu */}
      {isOpen && (
        <div className="fixed bottom-24 right-8 z-50 animate-slide-up">
          <div className="bg-white border border-navy-200 shadow-2xl p-8 w-80">
            <h3 className="text-xl font-sans font-semibold text-navy-900 mb-4">
              Discutons de votre <span className="text-blue-600">projet</span>
            </h3>
            <p className="text-navy-600 text-sm mb-6 font-light">
              Contactez-moi directement pour une consultation personnalisée
            </p>
            <button
              onClick={handleWhatsAppClick}
              className="w-full bg-green-500 text-white py-4 hover:bg-green-600 transition-all duration-300 font-medium"
            >
              Ouvrir WhatsApp
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
